// src/modules/app-views/invoices/pages/Init/components/tableColumns/invoiceStatusColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import InvoiceStatusTag from 'modules/app-views/invoices/components/InvoiceStatusTag';
import DocumentValidationTag from 'components/core/DocumentValidationTag';
import translateX from 'utils/translateX';

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************

const cellStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 };

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Invoices-only status column.
// Renders InvoiceStatusTag + DocumentValidationTag side by side.
function invoiceStatusColumn(buildColumnProps, options = {}) {
  return {
    title: translateX('status'),
    dataIndex: 'status',
    ...buildColumnProps('status', { sort: true }),
    width: 130,
    align: 'center',
    render: (_, record) => {
      if (!record?.status) return '—';
      return (
        <div style={cellStyle}>
          <DocumentValidationTag data={record} />
          <InvoiceStatusTag data={record} />
        </div>
      );
    },
  };
}

export default invoiceStatusColumn;
